import {Injectable} from '@angular/core';
import {Observable, timer} from "rxjs";
import {map} from "rxjs/operators";

import {SNS_API_URL} from "../../defines/protocol";
import {ApiService} from "../api/api.service";
import {LayoutMgrService} from "../layout-mgr/layout-mgr.service";
import {MP_RESULT} from "../../components/common-popups/msg-popup.component";


export type SnsInfo = {
  naver?: boolean;
};


@Injectable({
  providedIn: 'root'
})
export class SnsService {

  constructor(
    private api: ApiService,
    private lm: LayoutMgrService,
  ) {
  }

  public GetSnsInfo(): Observable<SnsInfo> {
    const url = SNS_API_URL;

    return this.api.Get(url).pipe(
      map(data => {
        console.log('SnsService::GetSnsInfo()', url, data);

        const snsInfo: SnsInfo = {};
        snsInfo.naver = data?.naver === 'Y';

        return snsInfo;
      })
    );
  }

  public ConnectNaverLogin(): Observable<void> {
    return new Observable<void>((observer) => {
      this.lm.OpenNaverLoginPopup().subscribe(
        (naverKey) => {
          if (!SnsService.isValidNaverKey(naverKey)) {
            if (naverKey === null) {
              // 사용자가 팝업에서 취소를 누른 정상 경로.
              observer.complete();
              return;
            }
            // popup이 비정상 페이로드를 빈 문자열로 전달하거나 향후 popup의
            // 검증이 회귀했을 때 사용자에게 실패를 안내하고 호출자에게도
            // 에러로 전파한다.
            console.error('SnsService::ConnectNaverLogin() invalid naverKey payload:', naverKey);
            this.lm.OpenMsgPopupAlert(
              '네이버 인증 정보를 받아오지 못했습니다. 잠시 후 다시 시도해 주세요.',
              '네이버 연동 실패',
            ).subscribe({
              error: (err) => console.error('SnsService::ConnectNaverLogin() alert popup error:', err),
            });
            observer.error(new Error('INVALID_NAVER_KEY'));
            return;
          }

          const url = SNS_API_URL + 'naver/' + encodeURIComponent(naverKey) + '/';
          this.api.Post(url, {}).subscribe(
            () => {
              observer.next();
              observer.complete();

              timer(200).subscribe({
                next: () => {
                  this.lm.OpenMsgPopup({
                    title: '책갈피 연동 성공',
                    msg: '책갈피와 네이버 아이디가 연동이 되었습니다.',
                    btnOk: '확인',
                  }).subscribe({
                    error: (err) => console.error('SnsService::ConnectNaverLogin() success popup error:', err),
                  });
                },
                error: (err) => console.error('SnsService::ConnectNaverLogin() success timer error:', err),
              });
            },
            (error) => {
              observer.error(error);
            }
          );
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  // popup 측 검증을 통과하지 못한 비정상 페이로드가 빈 문자열로 들어오는 경로와
  // 향후 popup 회귀를 대비한 서비스 측 백스톱. 정확히 '[object Object]' 문자열만
  // 별도로 차단하고, 그 외 임의의 객체 문자열화 형태는 popup의 정규식 검증에
  // 위임한다.
  public static isValidNaverKey(value: unknown): value is string {
    if (typeof value !== 'string') {
      return false;
    }
    const trimmed = value.trim();
    if (trimmed.length === 0) {
      return false;
    }
    if (trimmed === '[object Object]') {
      return false;
    }
    return true;
  }


  public DisconnectNaverLogin(): Observable<void> {
    return new Observable(observer => {
      const url = SNS_API_URL + 'naver/';

      this.lm.OpenMsgPopup({
        title: '책갈피와 네이버 아이디 연동 해제',
        msg: '연동을 해제 하더라도 책갈피의 내용은 유지됩니다.',
        btnOk: '연동 해제',
        btnCancel: '취소',
      }).subscribe(data => {
        if (data === MP_RESULT.OK) {
          this.api.Delete(url).subscribe(
            () => {
              observer.next();
              observer.complete();
            },
            (error) => {
              observer.error(error);
            }
          );
        } else {
          observer.complete(); // 또는 observer.next(); 를 호출할 수도 있습니다.
        }
      });
    });
  }

}
